<template>
  <div class="sidebar">
    <div class="p-3 logo-panel d-none d-md-block">
      <img id="zone-logo" src="../../../assets/img/zone_logo.png" alt="Logo aplikacji Zone"/>
      <h1 class="logo-text">
        Zintegrowany System Wsparcia Polityk i Programów Ograniczenia Niskiej Emisji
      </h1>
    </div>

    <div class="menu-label d-none d-md-block" :class="{'selected-menu-label': $route.name === 'welcome'}" v-if="isUserLogged">
      <router-link :to="{ name: 'welcome' }">
        <b-icon-house-door font-scale="1.4" />
        Strona główna
      </router-link>
    </div>

    <div class="menu-label d-none d-md-block" :class="{'selected-menu-label': $route.name === 'buildings'}" v-if="isUserLogged">
      <router-link :to="{ name: 'buildings' }">
        <b-icon-building font-scale="1.4" />
        Budynki
      </router-link>
    </div>

    <div class="menu-label d-none d-md-block" :class="{'selected-menu-label': $route.name === 'declarations'}" v-if="isUserLogged">
      <router-link :to="{ name: 'declarations' }" class="">
        <b-icon-file-text font-scale="1.4" />
        Deklaracje
      </router-link>
    </div>

    <div class="menu-label d-none d-md-block" :class="{'selected-menu-label': $route.name === 'receipts'}" v-if="isUserLogged">
      <router-link :to="{ name: 'receipts' }" class="">
        <b-icon-download font-scale="1.4" />
        Pobierz swoją deklarację
      </router-link>
    </div>

    <div class="mobile-menu d-block d-md-none">
      <img id="zone-logo" src="../../../assets/img/zone_logo.png" alt="Logo aplikacji Zone" v-if="isUserLogged" />
      <img id="zone-logo" class="lonely" src="../../../assets/img/zone_logo.png" alt="Logo aplikacji Zone" v-if="!isUserLogged" />
      <router-link :to="{ name: 'welcome' }" v-if="isUserLogged">
        <b-icon-house-door font-scale="1.3" />
      </router-link>
      <router-link :to="{ name: 'buildings' }" v-if="isUserLogged">
        <b-icon-building font-scale="1.3" />
      </router-link>
      <router-link :to="{ name: 'declarations' }" class="" v-if="isUserLogged">
        <b-icon-file-text font-scale="1.3" />
      </router-link>
      <router-link :to="{ name: 'receipts' }" class="" v-if="isUserLogged">
        <b-icon-download font-scale="1.3" />
      </router-link>
    </div>

    <div class="bottom-logo-container d-none d-md-block">
      <p>
        <a href="https://ceeb.gov.pl/polityka_prywatnosci.pdf" target="_blank">Polityka prywatności &raquo;</a>
      </p>
      <p>
        <a href="https://ceeb.gov.pl/deklaracja_dostepnosci.pdf" target="_blank">Deklaracja dostępności &raquo;</a>
      </p>
      <img id="gunb-logo" src="./../../../assets/img/gunb_logo.jpg" alt="Logo GUNB"/>
      <p>
        Główny Urząd Nadzoru Budowlanego
      </p>
      <p>
        ul. Krucza 38/42, 00-926 Warszawa
      </p>
      <p>
        Wersja: {{ version }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  props: ['version'],
  computed: {
    isUserLogged() {
      return ((this.$store.state.currentUserData) && ('pesel' in this.$store.state.currentUserData) && (this.$store.state.currentUserData.pesel));
    }
  }
}
</script>

<style scoped>
.bottom-logo-container {
  text-align: center;
  color: #FFFFFF;
  font-size: 0.8rem;
}

.bottom-logo-container p {
  padding: 0;
  margin: 0
}

#gunb-logo {
  margin: auto;
  width: 5rem;
}

a, a:hover, a:active {
  color: #FFFFFF;
}

.sidebar {
  position: fixed;
  background: #202f64;
  width: 17.3em;
  height: 100vh;
}

@media screen and (max-width: 768px) {
  .sidebar {
    width: 100%;
    height: 3em;
    z-index: 2;
  }
}

.logo-panel {
  height: 9rem;
  display: flex;
  padding-top: 1.2rem !important;
  margin-bottom: -1.9rem;
}

.logo-text {
  font-size: 0.7rem;
  padding: 0.5rem;
  color: #fff;
  line-height: 1rem;
  float: right;
  width: 75%;
}

#zone-logo {
  display: inline;
  max-height: 50%;
  width: auto;
  height: auto;
}

.mobile-menu #zone-logo {
  height: 2.6em;
  margin: 0.2em;
  margin-top: -0.6em;
}

.mobile-menu #zone-logo.lonely {
  height: 2.6em;
  margin: 0.2em;
  margin-top: 0.1em;
}

.menu-label {
  cursor: pointer;
  color: #fff;
  height: 3rem;
  padding: 0.5rem 0;
}

.menu-label a {
  font-size: 1rem;
}

.menu-label svg, .menu-label .zone-icon {
  margin-left: 1.8rem;
}

.menu-label:hover, .selected-menu-label {
  border-right: 0.4rem solid #f8c537;
}

.bottom-logo-container {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 10rem;
}

#user-pulpit {
  padding-left: .2rem;
}

.mobile-menu a {
  margin-left: 1em;
  line-height: 2.4em;
  font-size: 1.5em;
}

.mobile-menu .zone-icon {
  width: 1.5em;
  height: 1.5em;
}
</style>
